import React from "react";

const Quotes = () => {
  return (
    <div style={{ color: "#444" }}>
      <p>
        [1]
        中国第一个拥有公交车的城市.https://www.sohu.com/a/684495479_121123756
      </p>
      <p>
        [2] 中国发展新能源公交遇难题：电池寿命
        https://m.in-en.com/article/html/energy-2222811.shtml
      </p>
      <p>
        [3] 再见！上海滩百年老式“辫子电车”.
        https://ish.xinmin.cn/xnjx/2014/07/01/24671482.html
      </p>
      <p>
        [4] 世界首列氢燃料混合动力有轨电车在唐山下线.
        https://www.gov.cn/xinwen/2016-04/27/content_5068552.htm
      </p>
      <p>
        [5] 老电车票上 看百廿年天津公交.
        https://whly.tj.gov.cn/tjswlzxw/jgbn/whtj/jgzt/202405/t20240507_6618422.html
      </p>
      <p>
        [6] 2010-2023年交通运输行业发展统计公报.
        https://www.mot.gov.cn/fenxigongbao/hangyegongbao/
      </p>
    </div>
  );
};

export default Quotes;
